import { apiRoutes } from '../../api-routes';
import { httpClient } from '../../util';
import type { TransactionResponse } from './types';

export const getPaymentTransactionStatusFn = async (id: string) => {
  const response = await httpClient.get<TransactionResponse>(
    apiRoutes.payment.transaction_status_private(id)
  );

  return response.data;
};
